import React from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';

import {
  Container,
  Badge,
  TitleContent,
  Title,
  DescriptionType,
  BadgeTop,
  BadgeBottom,
  BadgeContent,
  BadgeBorder,
  BodyBadgeTop,
  BodyBadgeBottom,
  BodyBadgeContent,
  BodyBadge,
  ImageContainer,
  DescriptionContent,
  ImageType,
} from './style';

interface Props {
  allianceName: string;
  initialColor: string;
  finalColor: string;
  logo: string;
  type: string;
}

const AllianceCard = ({ allianceName, initialColor, finalColor, logo, type }: Props) => {
  const { t } = useStoreTranslation();
  return (
    <Container initialColor={initialColor} finalColor={finalColor}>
      <Badge>
        <BadgeBorder>
          <BadgeTop />
          <BadgeContent />
          <BadgeBottom />
        </BadgeBorder>
        <BodyBadge>
          <BodyBadgeTop />
          <BodyBadgeContent>
            <ImageContainer>
              <img alt={allianceName} src={`/images/alliances/${logo}`} />
            </ImageContainer>
          </BodyBadgeContent>
          <BodyBadgeBottom />
        </BodyBadge>
      </Badge>
      <TitleContent>
        <Title>{allianceName}</Title>
      </TitleContent>
      {type === 'Airline' ? (
        <DescriptionContent>
          <DescriptionType>{t('allianceCard.typeAirline')}</DescriptionType>
          <ImageType src="/images/airline-white.svg" />
        </DescriptionContent>
      ) : (
        <DescriptionContent>
          <DescriptionType>{t('allianceCard.typeHotel')}</DescriptionType>
          <ImageType src="/images/bedroom-white.svg" />
        </DescriptionContent>
      )}
    </Container>
  );
};

export default AllianceCard;
